<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('pharmacy.Add scientific-drugs-names')
          : $t('pharmacy.Edit scientific-drugs-names')
      "
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group
              :label="$t('pharmacy.scientific-drugs-names')"
              label-for="name"
            >
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('pharmacy.scientific-drugs-names')"
              />
            </b-form-group>
          </b-col>
          <!-- <b-col  md="" >
            <AutoComplete
              v-model="EditForm.items"
              :label="$t('common.drugs')"
              :placeholder="$t('common.drugs')"
              param-query="name"
               endpoint="item"
              text-title="name"
              multiple
              :close-on-select="false"
              keyword="name"
              :other-query="`filter[type]=pharmacy`"
            />
          </b-col> -->
        </b-row>
      </b-card-text>
    </b-modal>

    <!-- Drugs List Modal -->
    <b-modal
      id="modal-drugs-list"
      centered
      size="lg"
      :title="$t('common.drugs')"
      ok-only
    >
      <b-card-text>
        <div v-if="selectedDrugs.length > 0">
          <b-list-group>
            <b-list-group-item
              v-for="(item, index) in selectedDrugs"
              :key="item.id"
              class="d-flex justify-content-between align-items-center"
            >
              <span>{{ index + 1 }}. {{ item.name }}</span>
            </b-list-group-item>
          </b-list-group>
        </div>
        <div v-else>
          <p class="text-muted">{{ $t('common.no-data') }}</p>
        </div>
      </b-card-text>
    </b-modal>

    <b-card :title="$t('pharmacy.scientific-drugs-names')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("pharmacy.Filter scientific-drugs-names") }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group
              :label="$t('pharmacy.scientific-drugs-names')"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="drugName"
                :placeholder="$t('pharmacy.scientific-drugs-names')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getDrugsNames()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("pharmacy.scientific-drugs-names") }}</h2>
          <b-button variant="primary" @click="show(EditForm, 'create')">
            {{ $t("pharmacy.Add scientific-drugs-names") }}
          </b-button>
        </div>

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <ActionsButtons
                deletePerm="delete-surgery"
                editPerm="update-surgery"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
          <template #cell(drugs)="data">
            <div class="text-nowrap">
              <template v-if="data.item.items && data.item.items.length <= 2">
              <b-badge v-for="(item,i) in data.item.items" :key="item.id" variant="primary" style="margin-right: 2px;">
              {{ i+1 }} . {{ item.name }}
              </b-badge>
              </template>
              <template v-else-if="data.item.items && data.item.items.length > 2">
                <b-badge v-for="(item,i) in data.item.items.slice(0, 2)" :key="item.id" variant="primary" style="margin-right: 2px;">
                {{ i+1 }} . {{ item.name }}
                </b-badge>
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="showDrugsModal(data.item)"
                  style="margin-left: 5px;"
                >
                  +{{ data.item.items.length - 2 }} more
                </b-button>
              </template>
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Names</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getDrugsNames()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BBadge,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
export default {
  components: {
    DeleteModal,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BBadge,
    BListGroup,
    BListGroupItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    AutoComplete,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        items: [],
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "name", sortable: true, label: this.$t("common.name") },
        { key: "drugs", sortable: true, label: this.$t("common.drugs") },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      selectedDrugs: [],
    };
  },
  mounted() {
    this.getDrugsNames();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          name: "",
          items: [],
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.items = item.items ;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },

    showDrugsModal(item) {
      this.selectedDrugs = item.items || [];
      this.$bvModal.show("modal-drugs-list");
    },

    async getDrugsNames() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/drugScientificName?page=${this.page}&take=${this.take}&sort=-id&include[]=items`;

      if (this.drugName) {
        url += `&filter[name]=${this.drugName}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/drugScientificName/${this.deleteForm.id}`)
        .then((response) => {
          this.getDrugsNames();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      if (this.EditForm.items.length == 0) {
        this.EditForm.items.map(item => {
          this.EditForm.items = item.id
        })
      }
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/drugScientificName`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getDrugsNames();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/drugScientificName/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getDrugsNames();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
